import React from 'react';
import { IndependenceDay_class4_2026 } from '../views';


const SchoolProgrampage = () => {
  return <IndependenceDay_class4_2026 />;
};

export default SchoolProgrampage;